/* tslint:disable */
/* eslint-disable */
/**
 * Exyzt CouchDB
 * Exyzt CouchDB Common
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface GetBrandCar200Response
 */
export interface GetBrandCar200Response {
    /**
     * 
     * @type {number}
     * @memberof GetBrandCar200Response
     */
    'total_rows': number;
    /**
     * 
     * @type {number}
     * @memberof GetBrandCar200Response
     */
    'offset': number;
    /**
     * 
     * @type {Array<GetBrandCar200ResponseRowsInner>}
     * @memberof GetBrandCar200Response
     */
    'rows': Array<GetBrandCar200ResponseRowsInner>;
}
/**
 * 
 * @export
 * @interface GetBrandCar200ResponseRowsInner
 */
export interface GetBrandCar200ResponseRowsInner {
    /**
     * 
     * @type {string}
     * @memberof GetBrandCar200ResponseRowsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandCar200ResponseRowsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof GetBrandCar200ResponseRowsInner
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GetCarBrand200Response
 */
export interface GetCarBrand200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCarBrand200Response
     */
    'total_rows': number;
    /**
     * 
     * @type {number}
     * @memberof GetCarBrand200Response
     */
    'offset': number;
    /**
     * 
     * @type {Array<GetCarBrand200ResponseRowsInner>}
     * @memberof GetCarBrand200Response
     */
    'rows': Array<GetCarBrand200ResponseRowsInner>;
}
/**
 * 
 * @export
 * @interface GetCarBrand200ResponseRowsInner
 */
export interface GetCarBrand200ResponseRowsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCarBrand200ResponseRowsInner
     */
    'id': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetCarBrand200ResponseRowsInner
     */
    'key': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof GetCarBrand200ResponseRowsInner
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GetCountriesAlpha2200Response
 */
export interface GetCountriesAlpha2200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCountriesAlpha2200Response
     */
    'total_rows': number;
    /**
     * 
     * @type {number}
     * @memberof GetCountriesAlpha2200Response
     */
    'offset': number;
    /**
     * 
     * @type {Array<GetCountriesAlpha2200ResponseRowsInner>}
     * @memberof GetCountriesAlpha2200Response
     */
    'rows': Array<GetCountriesAlpha2200ResponseRowsInner>;
}
/**
 * 
 * @export
 * @interface GetCountriesAlpha2200ResponseRowsInner
 */
export interface GetCountriesAlpha2200ResponseRowsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCountriesAlpha2200ResponseRowsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCountriesAlpha2200ResponseRowsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof GetCountriesAlpha2200ResponseRowsInner
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GetCountriesAlpha3200Response
 */
export interface GetCountriesAlpha3200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCountriesAlpha3200Response
     */
    'total_rows': number;
    /**
     * 
     * @type {number}
     * @memberof GetCountriesAlpha3200Response
     */
    'offset': number;
    /**
     * 
     * @type {Array<GetCountriesAlpha3200ResponseRowsInner>}
     * @memberof GetCountriesAlpha3200Response
     */
    'rows': Array<GetCountriesAlpha3200ResponseRowsInner>;
}
/**
 * 
 * @export
 * @interface GetCountriesAlpha3200ResponseRowsInner
 */
export interface GetCountriesAlpha3200ResponseRowsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCountriesAlpha3200ResponseRowsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCountriesAlpha3200ResponseRowsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof GetCountriesAlpha3200ResponseRowsInner
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GetCountriesNumber200Response
 */
export interface GetCountriesNumber200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCountriesNumber200Response
     */
    'total_rows': number;
    /**
     * 
     * @type {number}
     * @memberof GetCountriesNumber200Response
     */
    'offset': number;
    /**
     * 
     * @type {Array<GetCountriesNumber200ResponseRowsInner>}
     * @memberof GetCountriesNumber200Response
     */
    'rows': Array<GetCountriesNumber200ResponseRowsInner>;
}
/**
 * 
 * @export
 * @interface GetCountriesNumber200ResponseRowsInner
 */
export interface GetCountriesNumber200ResponseRowsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCountriesNumber200ResponseRowsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCountriesNumber200ResponseRowsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof GetCountriesNumber200ResponseRowsInner
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GetModelCar200Response
 */
export interface GetModelCar200Response {
    /**
     * 
     * @type {number}
     * @memberof GetModelCar200Response
     */
    'total_rows': number;
    /**
     * 
     * @type {number}
     * @memberof GetModelCar200Response
     */
    'offset': number;
    /**
     * 
     * @type {Array<GetModelCar200ResponseRowsInner>}
     * @memberof GetModelCar200Response
     */
    'rows': Array<GetModelCar200ResponseRowsInner>;
}
/**
 * 
 * @export
 * @interface GetModelCar200ResponseRowsInner
 */
export interface GetModelCar200ResponseRowsInner {
    /**
     * 
     * @type {string}
     * @memberof GetModelCar200ResponseRowsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetModelCar200ResponseRowsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof GetModelCar200ResponseRowsInner
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface GetVehicleType200Response
 */
export interface GetVehicleType200Response {
    /**
     * 
     * @type {number}
     * @memberof GetVehicleType200Response
     */
    'total_rows': number;
    /**
     * 
     * @type {number}
     * @memberof GetVehicleType200Response
     */
    'offset': number;
    /**
     * 
     * @type {Array<GetVehicleType200ResponseRowsInner>}
     * @memberof GetVehicleType200Response
     */
    'rows': Array<GetVehicleType200ResponseRowsInner>;
}
/**
 * 
 * @export
 * @interface GetVehicleType200ResponseRowsInner
 */
export interface GetVehicleType200ResponseRowsInner {
    /**
     * 
     * @type {string}
     * @memberof GetVehicleType200ResponseRowsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetVehicleType200ResponseRowsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof GetVehicleType200ResponseRowsInner
     */
    'value': string;
}

/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Countries name alpha 2 ISO 3166-1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesAlpha2: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ref_countries/_design/ref_countries/_view/by_alpha-2_fr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Countries name alpha 3 ISO 3166-1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesAlpha3: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ref_countries/_design/ref_countries/_view/by_alpha-3_fr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Countries name number ISO 3166-1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesNumber: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ref_countries/_design/ref_countries/_view/by_number_fr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Countries name alpha 2 ISO 3166-1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountriesAlpha2(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCountriesAlpha2200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountriesAlpha2(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Countries name alpha 3 ISO 3166-1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountriesAlpha3(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCountriesAlpha3200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountriesAlpha3(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Countries name number ISO 3166-1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountriesNumber(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCountriesNumber200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountriesNumber(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CountriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Countries name alpha 2 ISO 3166-1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesAlpha2(options?: any): AxiosPromise<GetCountriesAlpha2200Response> {
            return localVarFp.getCountriesAlpha2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Countries name alpha 3 ISO 3166-1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesAlpha3(options?: any): AxiosPromise<GetCountriesAlpha3200Response> {
            return localVarFp.getCountriesAlpha3(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Countries name number ISO 3166-1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesNumber(options?: any): AxiosPromise<GetCountriesNumber200Response> {
            return localVarFp.getCountriesNumber(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountriesApi - interface
 * @export
 * @interface CountriesApi
 */
export interface CountriesApiInterface {
    /**
     * 
     * @summary Get Countries name alpha 2 ISO 3166-1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApiInterface
     */
    getCountriesAlpha2(options?: AxiosRequestConfig): AxiosPromise<GetCountriesAlpha2200Response>;

    /**
     * 
     * @summary Get Countries name alpha 3 ISO 3166-1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApiInterface
     */
    getCountriesAlpha3(options?: AxiosRequestConfig): AxiosPromise<GetCountriesAlpha3200Response>;

    /**
     * 
     * @summary Get Countries name number ISO 3166-1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApiInterface
     */
    getCountriesNumber(options?: AxiosRequestConfig): AxiosPromise<GetCountriesNumber200Response>;

}

/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
export class CountriesApi extends BaseAPI implements CountriesApiInterface {
    /**
     * 
     * @summary Get Countries name alpha 2 ISO 3166-1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public getCountriesAlpha2(options?: AxiosRequestConfig) {
        return CountriesApiFp(this.configuration).getCountriesAlpha2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Countries name alpha 3 ISO 3166-1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public getCountriesAlpha3(options?: AxiosRequestConfig) {
        return CountriesApiFp(this.configuration).getCountriesAlpha3(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Countries name number ISO 3166-1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    public getCountriesNumber(options?: AxiosRequestConfig) {
        return CountriesApiFp(this.configuration).getCountriesNumber(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MobilityApi - axios parameter creator
 * @export
 */
export const MobilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the list of brand car
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCar: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ref_vehicle/_design/vehicle/_view/by_brand_without_position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all car brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarBrand: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ref_vehicle/_design/vehicle/_view/by_brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the list of model car
         * @param {string} [keys] Example - [\&quot;207\&quot;,\&quot;208\&quot;]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelCar: async (keys?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ref_vehicle/_design/vehicle/_view/by_models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)

            if (keys !== undefined) {
                localVarQueryParameter['keys'] = keys;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the list of type vehicules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleType: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ref_vehicle_type/_design/vehicle_type/_view/by_label`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MobilityApi - functional programming interface
 * @export
 */
export const MobilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MobilityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the list of brand car
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandCar(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBrandCar200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandCar(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all car brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarBrand(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCarBrand200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarBrand(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the list of model car
         * @param {string} [keys] Example - [\&quot;207\&quot;,\&quot;208\&quot;]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModelCar(keys?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetModelCar200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModelCar(keys, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the list of type vehicules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVehicleType(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVehicleType200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVehicleType(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MobilityApi - factory interface
 * @export
 */
export const MobilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MobilityApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the list of brand car
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCar(options?: any): AxiosPromise<GetBrandCar200Response> {
            return localVarFp.getBrandCar(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all car brands
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarBrand(options?: any): AxiosPromise<GetCarBrand200Response> {
            return localVarFp.getCarBrand(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the list of model car
         * @param {string} [keys] Example - [\&quot;207\&quot;,\&quot;208\&quot;]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModelCar(keys?: string, options?: any): AxiosPromise<GetModelCar200Response> {
            return localVarFp.getModelCar(keys, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the list of type vehicules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleType(options?: any): AxiosPromise<GetVehicleType200Response> {
            return localVarFp.getVehicleType(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MobilityApi - interface
 * @export
 * @interface MobilityApi
 */
export interface MobilityApiInterface {
    /**
     * 
     * @summary Get the list of brand car
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilityApiInterface
     */
    getBrandCar(options?: AxiosRequestConfig): AxiosPromise<GetBrandCar200Response>;

    /**
     * 
     * @summary Get all car brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilityApiInterface
     */
    getCarBrand(options?: AxiosRequestConfig): AxiosPromise<GetCarBrand200Response>;

    /**
     * 
     * @summary Get the list of model car
     * @param {string} [keys] Example - [\&quot;207\&quot;,\&quot;208\&quot;]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilityApiInterface
     */
    getModelCar(keys?: string, options?: AxiosRequestConfig): AxiosPromise<GetModelCar200Response>;

    /**
     * 
     * @summary Get the list of type vehicules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilityApiInterface
     */
    getVehicleType(options?: AxiosRequestConfig): AxiosPromise<GetVehicleType200Response>;

}

/**
 * MobilityApi - object-oriented interface
 * @export
 * @class MobilityApi
 * @extends {BaseAPI}
 */
export class MobilityApi extends BaseAPI implements MobilityApiInterface {
    /**
     * 
     * @summary Get the list of brand car
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilityApi
     */
    public getBrandCar(options?: AxiosRequestConfig) {
        return MobilityApiFp(this.configuration).getBrandCar(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all car brands
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilityApi
     */
    public getCarBrand(options?: AxiosRequestConfig) {
        return MobilityApiFp(this.configuration).getCarBrand(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the list of model car
     * @param {string} [keys] Example - [\&quot;207\&quot;,\&quot;208\&quot;]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilityApi
     */
    public getModelCar(keys?: string, options?: AxiosRequestConfig) {
        return MobilityApiFp(this.configuration).getModelCar(keys, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the list of type vehicules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MobilityApi
     */
    public getVehicleType(options?: AxiosRequestConfig) {
        return MobilityApiFp(this.configuration).getVehicleType(options).then((request) => request(this.axios, this.basePath));
    }
}


